export default __webpack_public_path__ + "static/media/icon_arrow_right_white.c7a566dc.svg";